import { NoteType } from './NoteType';

export class PetNote {
    constructor(sid: number = null, note: string, type: NoteType = NoteType.INFO) {
        this.sid = sid;
        this.note = note;
        this.type = type;
      }

    sid: number;
    note: string;
    type: NoteType;
}
